export const formatDateTime = (raw) => {
  const d = raw ? new Date(raw) : null;
  if (!d || Number.isNaN(d.getTime())) return '';
  return d.toLocaleString();
};

export const toEpochMillis = (raw) => {
  const d = raw ? new Date(raw) : null;
  if (!d || Number.isNaN(d.getTime())) return null;
  return d.getTime();
};

export const formatPopulation = (population, populationOptions) =>
  (population || [])
    .map((p) => populationOptions.find((opt) => opt.value === p)?.label || p)
    .join(', ');

const getEdgeCharacters = (text) => {
  const value = String(text || '');
  return {
    leading: value.match(/^[^\p{L}\p{N}]+/u)?.[0] || '',
    trailing: value.match(/[^\p{L}\p{N}]+$/u)?.[0] || '',
  };
};

export const formatWordWithSyllables = (word, { syllableSeparator = '/', originalText = '' } = {}) => {
  const syllables = Array.isArray(word?.syllables) ? word.syllables : [];
  const parts = syllables.map((s) => s?.text).filter(Boolean);
  const base = parts.length ? parts.join(syllableSeparator) : (word?.text || '');
  if (!base || !originalText) return base;

  const { leading, trailing } = getEdgeCharacters(originalText);
  const prefix = leading && !base.startsWith(leading) ? leading : '';
  const suffix = trailing && !base.endsWith(trailing) ? trailing : '';
  return `${prefix}${base}${suffix}`;
};

export const formatWordsWithSyllables = (words, { originalText = '', syllableSeparator = '/' } = {}) => {
  const safeWords = Array.isArray(words) ? words : [];
  const originalWords = String(originalText).trim().match(/\S+/gu) || [];

  return safeWords
    .map((word, index) => formatWordWithSyllables(word, {
      syllableSeparator,
      originalText: originalWords[index],
    }))
    .filter((text) => text != null && String(text).length);
};

export const formatSentenceWithSyllables = (
  words,
  { originalText = '', wordSeparator = ' ', syllableSeparator = '/' } = {}
) => {
  return formatWordsWithSyllables(words, { originalText, syllableSeparator }).join(wordSeparator);
};
